import { render } from "./Landing.vue?vue&type=template&id=70052c22&scoped=true&ts=true&lang=pug"
import script from "./Landing.vue?vue&type=script&lang=ts&setup=true"
export * from "./Landing.vue?vue&type=script&lang=ts&setup=true"

import "./Landing.vue?vue&type=style&index=0&id=70052c22&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70052c22"]])

export default __exports__